import Icon from '@mdi/react'
import styled from 'styled-components'

import theme from 'theme_'
import { CommonLink } from 'components/Button'

export const StyledDomainsNavToRoot = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: ${theme.spacing.base};
`

export const NavToRootIcon = styled(Icon)<{ $disabled?: boolean }>`
  color: ${(p) =>
    p.$disabled ? theme.colors.duneWarmGrey : theme.colors.horizonOrange};
`

export const NavToRootLink = styled(CommonLink)`
  display: flex;
  align-items: center;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`

export const NavToRootDash = styled.span`
  display: none;
  font-weight: 600;
  font-size: 14px;

  @media ${theme.devices.desktop} {
    display: inline;
    margin-left: ${theme.spacing.base};
  }
`
